import "./styles/global.scss";
import "./styles/_override.scss";
import Routes from "./routes/Router";
import isUnsupporteddevice from "@utils/isUnsupporteddevice";



export default function App() {
  const isNotSupported = isUnsupporteddevice();
  return (
    <div>
      {isNotSupported && <div>Responsive Warning</div>}
      <Routes />
    </div>
  );
}